module.exports = __webpack_public_path__ + "img/saheli_back.fe5da41c.jpg";